import { useState, useEffect } from 'react';
import { fetchAlertsApi } from '../../store/app/apis';
import { getTime } from '../../utils';
import { connect } from 'react-redux';
import styles from './Alerts.module.css';
import { TablePagination } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

export function Alerts({ logtype, alerts, fetchAlertsApi }) {
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const params = useParams();
  let navigate = useNavigate();
  useEffect(() => {
    var payload = {};
    payload['size'] = rowsPerPage;
    payload['page'] = page + 1;
    if (logtype === 'service') {
      payload[logtype] = params.id;
    } else {
      payload[logtype] = [params.id];
    }
    fetchAlertsApi(payload).then((result) => setCount(result));
  }, [page, params.id, logtype, rowsPerPage]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const getServiceDetailPage = (event, id) => {
    event.preventDefault();
    navigate(`/dashboard/details/${id}`);
  };
  const styling = {
    '& .MuiTablePagination-toolbar': {
      paddingRight: '20px',
      bottom: '0px',
      right: '0px',
      position: 'fixed',
      width: '100%',
      backgroundColor: '#ebedef',
    },
    '& .MuiIconButton-root': {
      padding: '0px',
      boxShadow: 'none',
    },
  };

  return (
    <div>
      <div className={styles.alerts}>
        <table>
          <thead>
            <tr>
              {logtype === 'project' && <th style={{ textAlign: 'left', paddingLeft: '25px' }}>Service</th>}
              <th>Time</th>
              <th style={{ textAlign: 'left', paddingLeft: '25px' }}>Alerts</th>
            </tr>
          </thead>
          <tbody>
            {alerts?.map((alert) => (
              <tr>
                {logtype === 'project' && (
                  <td style={{ textAlign: 'left', paddingLeft: '25px' }}>
                    <a
                      href={`/dashboard/details/${alert?.service}`}
                      onClick={(event) => {
                        getServiceDetailPage(event, alert?.service);
                      }}
                      style={{ textDecoration: 'none' }}
                    >
                      {alert?.sname}
                    </a>
                  </td>
                )}
                <td>{getTime(alert?.ct)}</td>
                <td style={{ textAlign: 'left' }}>{alert?.msg || 'No message'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      \{' '}
      <TablePagination
        rowsPerPageOptions={[10, 15, 25, 50, 100]}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPage={rowsPerPage}
        count={count}
        page={page}
        onPageChange={handleChangePage}
        sx={styling}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  alerts: state.app.alerts,
});
const mapDispatchToProps = {
  fetchAlertsApi,
};

export default connect(mapStateToProps, mapDispatchToProps)(Alerts);
